import React from "react"
import { repeatedStringWithRandomStuff } from "../helper"

const HomeHero = () => {
  const greeting = repeatedStringWithRandomStuff("HELLO", " ", 50)
  return (
    <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-full w-full+ -z-1 text-hero-xl font-heading text-charcoal leading-flat transform -rotate-9 lg:overflow-hidden">
      {greeting}
    </div>
  )
}
export default HomeHero
